import React from "react";
import { connect } from "react-redux";

import ActivityListItem from "../../components/admin/ActivityListItem";
import Loader from "../../components/loaders/Loader";

import { IAppState } from "../../state/Store";
import {
    initialiseActivity,
    StopWatchActivity,
    WatchActivity,
} from "../../state/administration/Activity";
import UserActivity from "../../types/admin/UserActivity";

import "./ActivityList.scss";
import ActivityListItemGroup from "./ActivityListItemGroup";
import School from "../../types/core/School";
import { initialiseSchoolDetails } from "../../state/core/School";

interface ActivityListProps {
    school?: School;
    schoolStatus?: string;
    activityStatus?: string;
    groupBy?: string;
    activity?: UserActivity[];

    initialiseActivity?: () => void;
    initialiseSchoolDetails?: () => void;
}

interface ActivityListState {}

class ActivityList extends React.Component<
    ActivityListProps,
    ActivityListState
> {
    componentDidMount(): void {
        this.props.initialiseActivity();
        this.props.initialiseSchoolDetails();
    }

    componentWillUnmount(): void {
        if (this.props.school) StopWatchActivity(this.props.school.id);
    }

    render() {
        if (
            this.props.activityStatus === "succeeded" &&
            this.props.schoolStatus === "succeeded"
        )
            WatchActivity(this.props.school.id);

        let workingSet: Record<string, UserActivity[]> = {};
        if (this.props.groupBy)
            workingSet = this.props.activity.reduce((prev, current) => {
                if (!prev[current[this.props.groupBy]])
                    prev[current[this.props.groupBy]] = [];
                prev[current[this.props.groupBy]].push(current);
                return prev;
            }, {} as Record<string, UserActivity[]>);
        else workingSet["default"] = this.props.activity;

        return (
            <div className="activity-list items">
                {this.props.activityStatus === "succeeded" &&
                this.props.schoolStatus === "succeeded" ? (
                    this.props.groupBy ? (
                        Object.entries(workingSet).map(entry => (
                            <ActivityListItemGroup
                                key={entry[0]}
                                name={entry[0]}
                                data={entry[1]}
                            />
                        ))
                    ) : (
                        workingSet["default"].map((activity, index) => (
                            <ActivityListItem
                                key={index}
                                data={activity}
                            />
                        ))
                    )
                ) : (
                    <Loader></Loader>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    const { school, activity } = state.db;

    return {
        school: school.school,
        activity: activity.activity,
        schoolStatus: school.status,
        activityStatus: activity.activityStatus,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        initialiseActivity: () => dispatch(initialiseActivity()),
        initialiseSchoolDetails: () => dispatch(initialiseSchoolDetails()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivityList);
